// extracted by mini-css-extract-plugin
export default {"footer_text":"styles_footer_text__WrDOw","foter_links":"styles_foter_links__mnJQM","columns":"styles_columns__ozXgU","link_list":"styles_link_list__NCBQc"};